// extracted by mini-css-extract-plugin
export default {"FilmTabs":"os2xAsmvFdh-DOw3zp+okA==","Preview":"BYMdfc4LbKYeOJG2vPGfIw==","Thumbnail":"hkmxDIincD1g-ioCqE7pwQ==","tabText":"qbgJUkbQuLEX9Q3Gh+zZ1Q=="};